import {Component, Input, OnDestroy, OnInit, ViewChild, ViewChildren} from '@angular/core';
import {ControlContainer, NgForm, NgModel} from '@angular/forms';

import {EditModalSectionBaseComponent} from '../edit-modal-section-base.component';
import {EditModalService} from '../../../services/edit-modal.service';
import {SupplyAcquisitionTypeEnum} from '../../../enums/supply-acquisition-type.enum';
import {EnumUtils} from '../../../utils/enum.utils';
import {ProjectsConst} from '../../../consts/projects-consts';
import {MyTimePeriodEnum} from '../../../enums/my-time-period.enum';
import {BdLabeledDateInputComponent} from '@brother-apps/brother-dealerapp-shared-lib';
import {ModalVisibilityService} from '../../../services/modal-visibility.service';
import {Subscription} from 'rxjs';
import {ContactModel} from '../../../models/brother-contacts.model';
import {ProjectDistributorStatusEnum} from '../../../enums/project-distributor-status.enum';
import {RequestedSupplyInfoModel} from '../../../models/requested-supply-info.model';

/**
 * dialog step5 sections visibility controller
 *
 */
@Component({
    selector: 'app-projects-dialog-step5-sections-controller',
    templateUrl: './dialog-step5-sections-controller.component.html',
    styleUrls: ['./dialog-step5-sections-controller.component.scss'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class ProjectsDialogStep5SectionsControllerComponent extends EditModalSectionBaseComponent implements OnInit, OnDestroy {

    // public supplyAcquisitionTypeEnum = SupplyAcquisitionTypeEnum;
    @Input() public forceFormValidationVisibility: boolean;
    private supplyDistributorChoices: { label: string, labelClass: string, itemClass?: string, id?: number }[];
    private supplyDistributorMPSChoices: string[];
    private supplyDistributorValues: number[];
    private supplyDistributorMPSValues: number[];
    private lastUsedSupplyAqMode: string;
    private lastUsedInactiveSupplyAqModeDistributorIdStorage: number;
    private brotherInternationalGmbHId: number;

    private inactiveSupplyDistributorIds: number[];

    @ViewChild('rolloutStartNgModel', {static: true}) rolloutStartNgModel: NgModel;
    @ViewChild('rolloutEndNgModel', {static: true}) rolloutEndNgModel: NgModel;
    @ViewChildren(BdLabeledDateInputComponent) bdLabeledDateInputs: BdLabeledDateInputComponent[];
    private closeEditDialogModalsSub: Subscription;
    private quoteClosingDateChangedSub: Subscription;

    constructor(
        public editModalService: EditModalService,
        private modalVisibilityService: ModalVisibilityService
    ) {
        super(editModalService);
    }

    public ngOnInit() {
        super.ngOnInit();
        this.closeEditDialogModalsSub = this.modalVisibilityService.closeEditDialogModalsRequestAnnounced$.subscribe(sourceId => {

            if (sourceId !== 'edit-modal_clicked') {
                this.bdLabeledDateInputs.forEach(component =>
                    component.hideDatePicker()
                );
            }
        });

        this.quoteClosingDateChangedSub = this.editModalService.quoteClosingDateChangedAnnounced$.subscribe(_ => {
            if (this.rolloutStartNgModel) {
                this.rolloutStartNgModel.control.updateValueAndValidity();
            }
        });
    }


    public onNoSupplyBtnClicked() {
        this.model.project.supplyAcquisitionType = EnumUtils.getKeyByValue(SupplyAcquisitionTypeEnum, SupplyAcquisitionTypeEnum.NONE);
        this.editModalService.updateActiveProjectContainerExistenceValidationHelperStatus();
    }

    public getTimePeriodInMonthsChoices(): string[] {
        return this.getTimePeriodInMonthsValues().map(v => v.toString());
    }

    public getTimePeriodInMonthsValues(): number[] {
        return [+MyTimePeriodEnum.TP36, +MyTimePeriodEnum.TP48, +MyTimePeriodEnum.TP60];
    }



    // should return all distributors including bortherInternationalGmbH
    public getSupplyDistributorMPSChoices(): string[] {

        if (!this.supplyDistributorMPSChoices && this.model?.supplyDistributors) {
            this.supplyDistributorMPSChoices = this.model.supplyDistributors.map(distributor => {
                return distributor.name;
            });
        }

        return this.supplyDistributorMPSChoices;
    }

    private filterOutMpsBrotherSupplyDistributorName(contacts): ContactModel[] {
        return contacts && contacts.filter(k => k.name !== ProjectsConst.MPS_BROTHER_SUPPLY_DISTRIBUTOR_NAME);
    }


    // itemClass can be used to hide inactive items by setting itemClass = 'hidden'
    // should return all distributors except bortherInternationalGmbH and inactive ones
    public getSupplyDistributorChoices(): { label: string, labelClass: string, itemClass?: string,  id?: number  }[] {
        if (!this.supplyDistributorChoices && this.model?.filteredSupplyDistributors) {
            this.supplyDistributorChoices = this.model.filteredSupplyDistributors
                .map(distributor =>
                    ({
                        label: distributor.name + this.getDistributorStatusHtml(distributor.status),
                        labelClass: ProjectDistributorStatusEnum[distributor.status] === ProjectDistributorStatusEnum.INACTIVE ? 'inactive' : '',
                        itemClass: ProjectDistributorStatusEnum[distributor.status] === ProjectDistributorStatusEnum.INACTIVE ? 'hidden' : '',
                        id: distributor.id
                    })
                );
        }
        return this.supplyDistributorChoices;
    }


    private getDistributorStatusHtml(status: string): string {
        if (ProjectDistributorStatusEnum[status] === ProjectDistributorStatusEnum.INACTIVE) {
            return ' <b>(inaktiv)</b>';
        }
        return '';
    }

    // should return all distributors including bortherInternationalGmbH
    public getSupplyDistributorMPSValues(): number[] {
        if (!this.supplyDistributorMPSValues && this.model && this.model.supplyDistributors) {
            this.supplyDistributorMPSValues = this.model.supplyDistributors.map(distributor => {
                return distributor.id;
            });
        }

        return this.supplyDistributorMPSValues;
    }


    // should return all distributors except bortherInternationalGmbH and inactive ones
    // also set the filteredSupplyDistributors which is used in getSupplyDistributorChoices to generate corresponding choices
    public getSupplyDistributorValues(): number[] {

        if (!this.model.filteredSupplyDistributors?.length) {
            this.model.filteredSupplyDistributors = this.filterOutMpsBrotherSupplyDistributorName( [...this.model.supplyDistributors]);
            if (!this.model.project.id) {
                // filter out inactive supply distributors
                this.model.filteredSupplyDistributors = this.model.filteredSupplyDistributors.filter(distributor => ProjectDistributorStatusEnum[distributor.status] !== ProjectDistributorStatusEnum.INACTIVE);
            }
            this.supplyDistributorChoices = null;
            this.getSupplyDistributorChoices();

        }


        this.supplyDistributorValues = this.model.filteredSupplyDistributors.map(distributor => distributor.id);
        return this.supplyDistributorValues;
    }

    public isPrintSmartSupplyAcquisitionType(): boolean {
        return this.editModalService.isPrintSmartSupplyAcquisitionType();
    }


    public isSupplyOrderActive() {
        return this.editModalService.isSupplyOrderActive();
    }

    public onSupplyAcquisitionChanged() {
        console.log('onSupplyAcquisitionChanged');

        // console.log('supplyDistributors:', this.model.supplyDistributors);
        if (this.lastUsedSupplyAqMode_IsMPSType() !== this.editModalService.isPrintSmartSupplyAcquisitionType()) {
            // MPS type differs from last used type

            // if brotherInternationalGmbHId is not initialized/ already known, find it
            if (!this.brotherInternationalGmbHId &&  this.model?.supplyDistributors?.length) {
                let exactBrotherNameFound = true;
                let bortherModel = null;
                // tslint:disable:max-line-length
                if (this.model.supplyDistributors && this.model.supplyDistributors[0].name === ProjectsConst.MPS_BROTHER_SUPPLY_DISTRIBUTOR_NAME) {
                    bortherModel = this.model.supplyDistributors;
                }
                if (!bortherModel) {
                    bortherModel = this.model.supplyDistributors.find(distributor => distributor.name === ProjectsConst.MPS_BROTHER_SUPPLY_DISTRIBUTOR_NAME);
                }

                if (!bortherModel) {
                    exactBrotherNameFound = false;
                    console.warn('"Brother International GmbH" was not found in supplyDealers');
                    bortherModel = this.model.supplyDistributors.find(distributor => distributor.name === 'Brother International')?.id;
                }
                if (!bortherModel) {
                    console.warn('"Brother International"  was not found in supplyDealers');
                    bortherModel = this.model.supplyDistributors.find(distributor => distributor.name.toLowerCase() === 'brother')?.id;
                }

                if (!bortherModel) {
                    console.error('"Brother"  was not found in supplyDealers, supplies distributor cannot be set to Brother International GmbH');
                    console.log('this.model.supplyDistributors', this.model.supplyDistributors);

                }

                if (!exactBrotherNameFound) {
                    console.warn('used "Brother International GmbH" replacement', bortherModel);
                }
                this.brotherInternationalGmbHId = bortherModel?.id;
            }

            if (this.editModalService.isPrintSmartSupplyAcquisitionType()) {
                // save user input and use brotherInternationalGmbHId  as active distributor
                this.lastUsedInactiveSupplyAqModeDistributorIdStorage = this.model.project.requestedSupplyInfo.supplyDistributorId;
                this.model.project.requestedSupplyInfo.supplyDistributorId = this.brotherInternationalGmbHId;
                console.log('distributor set to brother', this.model.project.requestedSupplyInfo.supplyDistributorId);
            } else {
                // load last supply distributor selected by user
                this.model.project.requestedSupplyInfo.supplyDistributorId = this.lastUsedInactiveSupplyAqModeDistributorIdStorage;
            }

        }


        if (this.editModalService.isPrintSmartSupplyAcquisitionType()) {
            this.editModalService.refreshAvailablePreselectedPrintSmartDeviceWithSupplyContainers();
            this.editModalService.refreshRequestedPrintSmartSupplyContainers();
        }
        this.lastUsedSupplyAqMode = this.model.project.supplyAcquisitionType;
        this.editModalService.updateActiveProjectContainerExistenceValidationHelperStatus();

    }


    public lastUsedSupplyAqMode_IsMPSType(): boolean {
        const supplyAcquisitionType = SupplyAcquisitionTypeEnum[this.lastUsedSupplyAqMode];
        return supplyAcquisitionType === SupplyAcquisitionTypeEnum.MPS_BASED_ON_PAGE_PRICE
            || supplyAcquisitionType === SupplyAcquisitionTypeEnum.MPS_BASED_ON_UNIT_COUNT;
    }

    public onTimePeriodInMonthsChanged(newValue: number) {


        this.model.project.requestedSupplyInfo.timePeriodInMonths = newValue;

        this.editModalService.updateMPSSuppliesAmounts();
    }

    public onRolloutStartChanged() {
        if (this.rolloutEndNgModel) {
            setTimeout(_ => {
                this.rolloutEndNgModel.control.updateValueAndValidity();
            }, 0);
        }

        if (!this.editModalService.isPrintSmartSupplyAcquisitionType()) {
            this.editModalService.updateGeneralSuppliesAmounts();
        }
    }

    public onRolloutEndChanged() {
        if (!this.editModalService.isPrintSmartSupplyAcquisitionType()) {
            this.editModalService.updateGeneralSuppliesAmounts();
        }
    }

    public projectRowItemsAmountComplyRules() {
        return this.editModalService.projectContainsAnythingToOrder();
    }

    public isMpsDisabled(): boolean {
        return !this.editModalService.someMpsDeviceOrderActive();
    }

    public getRolloutStartMinDay(): Date {
        // console.log('getRolloutStartMinDay', this.editModalService.getRolloutStartMinDay());
        return this.editModalService.getRolloutStartMinDay();
    }

    public getRolloutEndMinDate(rolloutStart: Date): Date {
        // console.log('getRolloutEndMinDate',this.editModalService.getRolloutEndMinDate(rolloutStart));
        return this.editModalService.getRolloutEndMinDate(rolloutStart);
    }

    public ngOnDestroy(): void {
        if (this.closeEditDialogModalsSub) {
            this.closeEditDialogModalsSub.unsubscribe();
        }
        if (this.quoteClosingDateChangedSub) {
            this.quoteClosingDateChangedSub.unsubscribe();
        }
    }

    // should return list of supply distributor ids that are inactive
    getInactiveSupplyDistributorIdsList(): number[] {
        this.inactiveSupplyDistributorIds = this.inactiveSupplyDistributorIds ||
            this.model.supplyDistributors.filter(distributor =>
            ProjectDistributorStatusEnum[distributor.status] === ProjectDistributorStatusEnum.INACTIVE)
            ?.map(distributor => distributor.id);
        return this.inactiveSupplyDistributorIds;
    }

    getSecondarySupplyDistributorValues(): number[] {
        let result = this.getSupplyDistributorValues();
        // add empty value that allows to reset the value to null
        result = [null, ...result];
        return result;
    }

    getSecondarySupplyDistributorChoices(): { label: string, labelClass: string, itemClass?: string, id?: number }[] {
        let result = this.getSupplyDistributorChoices();
        // add empty value that allows to reset the value to null
        result = [{label: 'Keine Auswahl', labelClass: ''}, ...result];

        // find the first choice that matches the selected productSupplyDistributorId
        // and set its class to 'hidden'
        // but do not modify the original array values
        const selectedSupplyDistributorId = this.model.project.requestedSupplyInfo.supplyDistributorId;
        if (selectedSupplyDistributorId) {
            const choiceIndex = result.findIndex(choice => choice.id === selectedSupplyDistributorId);
            if (choiceIndex !== -1) {
                // Create a copy of the choice object
                const choiceToHide = {...result[choiceIndex]};
                choiceToHide.itemClass = 'hidden';
                choiceToHide.labelClass = 'hidden';
                // Replace the original choice object with the modified copy in the array variable result
                result[choiceIndex] = choiceToHide;
            }
        }
        return result;
    }


    onSecondarySupplyDistributorChanged(requestedProductInfo: RequestedSupplyInfoModel, ngModel: NgModel): void {
        // There is a difference between null and undefined, 'Optional auswählen' === undefined and 'Keine Auswahl' === null
        // So after 'Keine Auswahl' is selected, we need to set it to undefined value,  to display 'Optional auswählen' instead selected value 'Keine Auswahl'
        if (!requestedProductInfo.secondarySupplyDistributorId) {
            requestedProductInfo.secondarySupplyDistributorId = -1; // without this line, the input value is not sometimes changed back to 'Optional auswählen'
            ngModel?.control.updateValueAndValidity();
            setTimeout(() => {
                requestedProductInfo.secondarySupplyDistributorId = undefined;
                ngModel?.control.updateValueAndValidity();
            }, 0);
        }
    }

    onProductSupplyDistributorChanged(requestedSupplyInfo: RequestedSupplyInfoModel): void {
        if (requestedSupplyInfo.supplyDistributorId === requestedSupplyInfo.secondarySupplyDistributorId) {
            requestedSupplyInfo.secondarySupplyDistributorId = undefined;
        }
    }
}
